export default __webpack_public_path__ + "static/media/CliO_Brochure_En_180910.3d4a9e03.pdf";